import http from '@/utils/request'
import defaultSettings from '@/settings'

// 直接通过覆盖的方式

/**
   * 获取功能菜单
   * @param {查询条件} data
   */
export function getAllMenuTreeTable(sysId) {
  return http.request({
    url: 'Menu/GetAllMenuTreeTable',
    method: 'get',
    params: { systemTypeId: sysId },
    baseURL: defaultSettings.apiSecurityUrl
  })
}
/**
   * 新增或修改保存
   * @param data
   */
export function saveMenu(data, url) {
  return http.request({
    url: url,
    method: 'post',
    data: data,
    baseURL: defaultSettings.apiSecurityUrl
  })
}
/**
   * 获取详情
   * @param {Id} Id
   */
export function getMenuDetail(id) {
  return http({
    url: 'Menu/GetById',
    method: 'get',
    params: { id: id },
    baseURL: defaultSettings.apiSecurityUrl
  })
}
/**
   * 批量设置启用状态
   * @param {id集合} ids
   */
export function setMenuEnable(data) {
  return http({
    url: 'Menu/SetEnabledMarkBatchAsync',
    method: 'post',
    data: data,
    baseURL: defaultSettings.apiSecurityUrl
  })
}
/**
   * 批量设为删除
   * @param {id集合} ids
   */
export function deleteSoftMenu(data) {
  return http({
    url: 'Menu/DeleteSoftBatchAsync',
    method: 'post',
    data: data,
    baseURL: defaultSettings.apiSecurityUrl
  })
}

/**
   * 批量删除
   * @param {id集合} ids
   */
export function deleteMenu(data) {
  return http({
    url: 'Menu/DeleteBatchAsync',
    method: 'delete',
    data: data,
    baseURL: defaultSettings.apiSecurityUrl
  })
}

/**
   * 查询所有可用的
   * @param {查询条件} data
   */
export function getMenuAllEnable() {
  return http.request({
    url: 'Menu/GetAllEnable',
    method: 'get',
    baseURL: defaultSettings.apiSecurityUrl
  })
}

/**
 * 根据菜单功能编码查询该页面操作功能
 * @param  code 字典编码
 * @returns
 */
export function getListMeunFuntionBymeunCode(code) {
  return http({
    url: 'Menu/GetListByParentEnCode',
    method: 'get',
    params: { enCode: code },
    baseURL: defaultSettings.apiHostUrl
  })
}
